export { getFlags } from './flags';
